<template>
  <div class="h-dialogContainer" v-if="hasReset">
    <div>
      <BaseBusiness :formParams='formParamsBase' :formId="formParamsBaseNew.formId" :reMountPage='reMount' ref="base" :opCode="opCode" :dialPlan="dialPlan" :funcKeyUp="bindOnJudgeNameLengthInfo"></BaseBusiness>
      <div id="template" class='row h-row-inputBox' v-if="showTemplate">
        <div class='col-sm-6 h-col-inputBox-t1'>
          <template v-if='showTemplate'>
            <div class='h-inputLit'>{{$t('SubscriberIms.template')}}</div>
            <ejs-dropdownlist v-if="showTemplate" :dataSource='templateInfo' :change= "templateChange"/>
          </template>
        </div>
      </div>
    </div>
    <div class="h-borderBox">
      <!--<div class="h-borderBox-top" style="height: 40px; background-color: #d9d9d9;">组服务信息</div>-->
      <div class="h-borderBox-top"  style="height: 40px; background-color: #d9d9d9; margin-bottom:10px;">
        <ejs-checkbox v-if="showCheckbox" :label="$t('SubscriberIms.tgrpserviceDiv')" @change="changeFun"></ejs-checkbox><span v-if="!showCheckbox">{{$t('SubscriberIms.tgrpserviceDiv')}}</span>
      </div>
        <div id="tgrpservice" style="padding: 8px;">
          <template>
            <BaseBusiness :formParams='formParamsGrpprofileInfo' :formId="formParamsGrpprofileInfoNew.formId" ref="grpprofileInfo" :opCode="opCode"></BaseBusiness>
          </template>
        </div>
    </div>
    <div class="h-borderBox" v-if="showTgrpAddition">
      <div class="h-borderBox-top" style="height: 40px; background-color: #d9d9d9; margin-bottom:10px;">
        <ejs-checkbox v-if="showCheckboxa" :label="$t('SubscriberIms.tgrpadditionalDiv')" @change="changeAdditionFun"></ejs-checkbox><span v-if="!showCheckboxa">{{$t('SubscriberIms.tgrpadditionalDiv')}}</span>
      </div>
      <div style="padding: 8px;">
        <template>
          <BaseBusiness :formParams='formParamsGrpAdditionInfo' :formId="formParamsGrpAdditionInfoNew.formId" ref="grpAdditionInfo" :opCode="opCode"></BaseBusiness>
        </template>
      </div>
    </div>
    <!--<div class="h-borderBox">-->
      <!--<div style="height: 40px; background-color: #d9d9d9; margin-bottom:10px;">群组补充信息</div>-->
      <!--<template>-->
        <!--<BaseBusiness :formParams='formParamsGrpAdditionInfo' :reMountPage='reMount' ref="grpAdditionInfo" formPattern="2"></BaseBusiness>-->
      <!--</template>-->
    <!--</div>-->
    <CustomDialog ref='qryVpnInfoPage' :element='dialog.element.eleQryVpnInfo' :styles='dialog.stylesWithIndex'>
      <template v-slot:dialog-content>
        <OrganizationalTree ref="organizationalTreeInner" :neid="neid" :vpndata="vpndata" :disableNodes="disableNode" :existFlag="false">></OrganizationalTree>
      </template>
    </CustomDialog>
  </div>
</template>

<script>
import BaseBusiness from '../U_BaseBusiness_New';
import SubscriberArr from '../../../../../plugins/subscriberArr';
import CustomDialog from '../../../../common/CustomDialog';
import OrganizationalTree from '../../../util/OrganizationalTree';
import { EventBus } from '../../../../../plugins/eventBus';
import SubscriberTool from '../../../util/parseFormNew/tools/subscriberTool';
import batchModCommon from '../batchModCommon';

export default {
  name: 'AddImsGroupDialog',
  components: {
    BaseBusiness,
    CustomDialog,
    OrganizationalTree,
  },
  mixins: [batchModCommon],
  props: [
    'neids',
    'opCode',
    'node'
  ],
  methods: {
    mainHandler(data, propinfo, response) {
      const $this = this;
      // $this.formParamsBase.formId = `${propinfo.opCode}baseBusiness`;
      // $this.formParamsGrpprofileInfo.formId = `${propinfo.opCode}grpprofileInfoBusiness`;
      $this.neid = propinfo.neid;
      // let subscriberArr = null;
      const arrBase = null;
      const arrDevice = null;
      const arrServe = null;
      const res = response.data.resultVal;
      const nameMap = new Map();
      // 获取带有[]的name列表
      res.forEach((item) => {
        const { name } = item;
        if (name.indexOf('[') > -1) {
          if (typeof (nameMap.get(name.split('[')[0])) !== 'undefined') {
            const nameArray = nameMap.get(name.split('[')[0]);
            nameArray.push(item);
            nameMap.set(name.split('[')[0], nameArray);
          } else {
            const nameArr = [];
            nameArr.push(item);
            nameMap.set(name.split('[')[0], nameArr);
          }
        }
      });
      const bussinessMap = new Map();
      // subscriberArr = new SubscriberArr(res);
      // _addFlag -1:批量添加 0:添加 1:修改 2:批量修改
      if (propinfo.opCode === 'mod') {
        this.info.vpnid = data[0].vpnid;
        // data[0].vpnid.value = propinfo.vpnname;
        console.log(data[0], this.info.vpnid);
        // data[0].vpnid = vpntree.$refs.tree1.getNode(vpnStr).text;
        const vpntree = this.$parent.$parent.$refs.modGroup.$parent.$parent.$parent.$parent.$refs.organizationalTree;
        if (data[0].vpnid === 0) {
          if (this.node.neNode.equipmentName === undefined) {
            data[0].vpnid = this.$t('SubscriberIms.organization');
          } else {
            data[0].vpnid = `${this.$t('SubscriberIms.organization')}[${this.node.neNode.equipmentName}]`;
          }
        } else {
          const vpnStr = `${propinfo.neid}_7_${data[0].vpnid}`;
          console.log(vpnStr);
          data[0].vpnid = vpntree.$refs.tree1.getTreeData(vpnStr)[0].text;
        }
        $this.vpndata = vpntree.initData;
        $this.disableNode = vpntree.disableNode;
        // subscriberArr.setDatas(data[0]);
        // bussinessMap = subscriberArr.getTempletByGroup(1);
        // $this.callPageShow($this, bussinessMap, subscriberArr, arrBase, arrServe, arrDevice, propinfo);
        // $this.callPageShow($this, bussinessMap, undefined, arrBase, arrServe, arrDevice, propinfo);
        $this.showTemplate = false;
        this.callPageShowNew(res, arrBase, arrDevice, data, propinfo);
        // this.$refs.base.$refs.bus.setData('vpnid', vpntree.$refs.tree1.getTreeData(vpnStr)[0].text);
        data[0].vpnid = this.info.vpnid;
      } else if (propinfo.opCode === 'batchMod') {
        const vpntree = this.$parent.$parent.$refs.modGroup.$parent.$parent.$parent.$parent.$refs.organizationalTree;
        $this.vpndata = vpntree.initData;
        $this.disableNode = vpntree.disableNode;
        // bussinessMap = subscriberArr.getTempletByGroup(2);
        // $this.callPageShow($this, bussinessMap, subscriberArr, arrBase, arrServe, arrDevice, propinfo);
        // $this.callPageShow($this, bussinessMap, undefined, arrBase, arrServe, arrDevice, propinfo);
        $this.showTemplate = false;
        $this.showCheckbox = true;
        $this.showCheckboxa = true;
        this.callPageShowNew(res, arrBase, arrDevice, data, propinfo);
      } else {
        $this.showTemplate = true;
        $this.handlerBasicInfo(propinfo, res, $this, bussinessMap, undefined, arrBase, arrServe, arrDevice, propinfo);
        // 获取模板信息templateInfo
        $this.initTemplateInfo();
      }
    },
    initState(arrBase, arrDevice, arrAddition) {
      console.log('nogroup=', arrBase);
      console.log('arrDevice=', arrDevice);
      // this.arrBaseBak = JSON.stringify(arrBase);
      // this.arrDeviceBak = JSON.stringify(arrDevice);
      // 初始化不分组字段showName前增加checkbox
      this.bindCheckbox('base', arrBase);
      if (this.showCheckbox) {
        this.setDisabled('base', arrBase);
        this.setDisabled('grpprofileInfo', arrDevice);
        arrAddition && this.setDisabled('grpAdditionInfo', arrAddition);
      }
    },
    // 增加checkbox
    // bindCheckbox(refName, arr) {
    //   arr.forEach((item) => {
    //     if (!item.batch_hidden && !item.hidden) { // 验证规则、不可操作、必填项
    //       const dom = document.getElementById(item.name);
    //       console.log(dom, dom.classList);
    //       dom.classList.remove('h-subscriber-nocheck-style');
    //       dom.classList.add('h-subscriber-hascheck-style');
    //       dom.children[0].onchange = this.changeBaseFun;
    //       dom.children[0].innerValue = item.name;
    //     }
    //   });
    //   this.$refs[refName].setDatas(arr);
    // },
    changeBaseFun(args, dom) {
      const arrBaseInfo = JSON.parse(this.arrBaseBak);
      if (args === undefined) {
        return;
      }
      console.log(args, dom);
      const name = args.path[5].__vue__.data.name;
      const arrBase = arrBaseInfo.filter((item) => item.name === name);
      if (args.target.checked) {
        this.setEnabled('base', arrBase);
        this.checkboxMap[name] = true;
      } else {
        this.setDisabled('base', arrBase);
        this.checkboxMap[name] = false;
      }
    },
    changeFun(args) {
      const arrDevice = JSON.parse(this.arrDeviceBak);
      // const arrBase = JSON.parse(this.arrBaseBak);
      if (args.checked) {
        // this.setEnabled('base', arrBase);
        this.setEnabled('grpprofileInfo', arrDevice);
        this.checkboxMap.grpprofileInfo = true;
      } else {
        // this.setDisabled('base', arrBase);
        this.setDisabled('grpprofileInfo', arrDevice);
        this.checkboxMap.grpprofileInfo = false;
      }
    },
    changeAdditionFun(args) {
      const arrAdditional = JSON.parse(this.arrAdditionalBak);
      // const arrBase = JSON.parse(this.arrBaseBak);
      if (args.checked) {
        // this.setEnabled('base', arrBase);
        this.setEnabled('grpAdditionInfo', arrAdditional);
        this.checkboxMap.grpAdditionInfo = true;
      } else {
        // this.setDisabled('base', arrBase);
        this.setDisabled('grpAdditionInfo', arrAdditional);
        this.checkboxMap.grpAdditionInfo = false;
      }
    },
    callPageShowNew(res, arrBase, arrDevice, data, propinfo) {
      const $this = this;
      const sub = new SubscriberTool();
      console.log('data', data);
      const resultMap = sub.$devideByGroupBy(res, data.length === 1 ? data[0] : data);
      arrBase = resultMap.get($this.formParamsBase.modelName);
      $this.formParamsBase = arrBase;
      arrDevice = resultMap.get($this.formParamsGrpprofileInfo.modelName);
      $this.formParamsGrpprofileInfo = arrDevice;
      const arrAdditional = resultMap.get($this.formParamsGrpAdditionInfo.modelName);
      $this.formParamsGrpAdditionInfo = arrAdditional;
      console.log(arrBase, arrDevice);
      //控制群组补充信息的box显隐
      if (propinfo.neversion && propinfo.neversion.includes(this.POC_VERSION_22)) {
        $this.showTgrpAddition = true;
      } else {
        $this.showTgrpAddition = false;
      }
      if (propinfo.opCode === 'batchMod') {
        this.arrBaseBak = JSON.stringify(arrBase);
        this.arrDeviceBak = JSON.stringify(arrDevice);
        if (propinfo.neversion && propinfo.neversion.includes(this.POC_VERSION_22)) {
          this.arrAdditionalBak = JSON.stringify(arrAdditional);
        }
      }
      if (propinfo.opCode === 'batchMod' || propinfo.opCode === 'mod') {
        setTimeout(() => {
          $this.bindClickAfterPageCreated();
          if ($this.showCheckbox) {
            $this.initState(arrBase, arrDevice, arrAdditional);
          }
        }, 300);
      }
      // else if (this.dialPlan === 5) {
      //   setTimeout(() => {
      //     $this.bindClickAfterPageCreatedForAdd();
      //   }, 200);
      // }
    },
    callPageShow($this, bussinessMap, subscriberArr, arrBase, arrServe, arrDevice, propinfo) {
      // arrBase = bussinessMap.get($this.formParamsBase.modelName);
      // $this.formParamsBase.json = arrBase;
      // $this.formParamsBase.formId = `${propinfo.opCode}baseBusiness`;
      // $this.formParamsBase.subObject = subscriberArr;
      //
      // arrDevice = bussinessMap.get($this.formParamsGrpprofileInfo.modelName);
      // $this.formParamsGrpprofileInfo.json = arrDevice;
      // $this.formParamsGrpprofileInfo.formId = `${propinfo.opCode}grpprofileInfoBussiness`;
      // $this.formParamsGrpprofileInfo.subObject = subscriberArr;

      // arrServe = bussinessMap.get($this.formParamsGrpAdditionInfo.modelName);
      // $this.formParamsGrpAdditionInfo.json = arrServe;
      // $this.formParamsGrpAdditionInfo.formId = `${propinfo.opCode}grpAdditionInfoBussiness`;
      // $this.formParamsGrpAdditionInfo.subObject = subscriberArr;
      // $this.reMount();
      // 后续需要注释掉下面代码
      if (propinfo.opCode === 'batchMod' || propinfo.opCode === 'mod') {
        setTimeout(() => {
          $this.bindClickAfterPageCreated();
        }, 200);
      } else if (this.dialPlan === 5) {
        setTimeout(() => {
          $this.bindClickAfterPageCreatedForAdd();
        }, 200);
      }
      // if (propinfo.opCode === 'batchMod') {
      //   setTimeout(() => {
      //     $this.bindStyleAfterPageCreated();
      //   }, 200);
      // }
    },
    /**
     * 区号、队号获取；组织架构值设置
     * @param propinfo
     * @param res
     * @returns {*}
     */
    handlerBasicInfo(propinfo, res, $this, bussinessMap, subscriberArr, arrBase, arrServe, arrDevice) {
      // 区号队号查询赋值
      this.paramForInner.vo['0'] = this.neid;
      this.$axios.post('/lte/ems/subscriber/imsunms/requestCommon', this.paramForInner).then((response) => {
        console.log('getZone=', response);
        if (response.status !== 200) {
          // this.$layer.alert({ msg: this.$t('SubscriberIms.requestResTip') });
          EventBus.$emit('toast', { type: 'warning', content: this.$t('SubscriberIms.requestResTip') });
          // bussinessMap = subscriberArr.getTempletByGroup(0);
        } else if (response.data === '' || response.data.errorCode !== '0') {
          // $this.$layer.alert({ msg: this.$t('SubscriberIms.checkZoneTip') });
          EventBus.$emit('toast', { type: 'warning', content: this.$t('SubscriberIms.checkZoneTip') });
          // bussinessMap = subscriberArr.getTempletByGroup(0);
        } else if (typeof (response.data) !== 'undefined' && response.data.resultVal.length > 0) {
          // bussinessMap = $this.setParameterWithDialplan(propinfo, response, res, bussinessMap, subscriberArr);
          // if (typeof (response.data.result[0].fleet) !== 'undefined' && response.data.result[0].fleet.length > 0) {
          //   response.data.result[0].fleet.forEach((item) => {
          //     fleetOptions.push({ showName: item, value: item });
          //   });
          // }
          $this.setParameterWithDialplan(propinfo, response, res, bussinessMap, subscriberArr);
        } else {
          // $this.$parent.$parent.$parent.$refs.layerDialog.show('请校验区号');
          // $this.$layer.alert({ msg: this.$t('SubscriberIms.checkZoneTip') });
          EventBus.$emit('toast', { type: 'warning', content: this.$t('SubscriberIms.checkZoneTip') });
          // bussinessMap = subscriberArr.getTempletByGroup(0);
        }
        this.callPageShowNew(res, arrBase, arrDevice, [], propinfo);
      });
    },
    setParameterWithDialplan(propinfo, response, res, bussinessMap, subscriberArr) {
      // 根据拨号方案设置队号、个号的范围---包括单开、批开组
      // 处理拨号方案:5 p3 4 dmr 6 zj-poc  队号信息
      const zoneOptions = [];
      const fleetOptions = [];
      const zoneRes = JSON.parse(response.data.resultVal);
      zoneRes.forEach((item) => {
        zoneOptions.push({ showName: item, value: item });
      });
      /**
       * 处理拨号方案:1 p3 6 zj-poc  队号信息;4 dmr没有队号
       */
      const _dialPlan = parseInt(propinfo.dialPlan, 0);
      if (_dialPlan === this.dialPlanList[1]) { // p3
        for (let index = 20; index <= 89; index++) {
          fleetOptions.push({ showName: index, value: index });
        }
      } else if (_dialPlan === this.dialPlanList[2]) { // zj-poc
        fleetOptions.push({ showName: 90, value: 90 });
        fleetOptions.push({ showName: 97, value: 97 });
        fleetOptions.push({ showName: 98, value: 98 });
        fleetOptions.push({ showName: 99, value: 99 });
      }
      this.fleetListDataNormal = fleetOptions;
      console.log('_dialPlan=', _dialPlan);
      this.dialPlan = _dialPlan;
      // 区号、队号下拉列表赋值
      res.forEach((item) => {
        if (item.name.indexOf('[zone]') > -1) {
          item.value = zoneOptions[0].value;
          item.options = zoneOptions;
        }
        if (item.name.indexOf('[fleet]') > -1) {
          if (_dialPlan === this.dialPlanList[0]) { // dmr拨号方案---隐藏队号
            item.hidden = true;
            item.batch_hidden = true;
          } else { // 其他拨号方案 ---队号初始值设置
            item.value = fleetOptions[0].value;
            item.options = fleetOptions;
          }
        }
        if (item.name.indexOf('[number]') > -1 || item.name.indexOf('[startNo]') > -1 || item.name.indexOf('[endNo]') > -1) {
          // 个号设置区间--- 验证规则
          if (item.validate || item.placeholder) {
            if (_dialPlan === this.dialPlanList[1]) {
              item.placeholder = '900~999';
              item.validate.range = [[900, 999], this.$t('SubscriberIms.noZoneDial1Tip')];
              item.validate.rangeLength = [[3,3],this.$t('SubscriberIms.solid_3')]
            } else if (_dialPlan === this.dialPlanList[0]) {
              if(this.checkDmrZone(zoneOptions[0].value)){
                item.placeholder = '00001~99999';
                item.validate.range = [[1, 99999], this.$t('SubscriberIms.numDialTip7')];
                item.validate.rangeLength = [[5,5],this.$t('SubscriberIms.solid_5')]
              }
              else{
                item.placeholder = '00000~99999';
                /*item.value = '00000';
                if (item.name.indexOf('[endNo]') > -1) {
                  item.value = '00100';
                }*/
                item.validate.range = [[0, 99999], this.$t('SubscriberIms.noZoneDial4Tip')];
                item.validate.rangeLength = [[5,5],this.$t('SubscriberIms.solid_5')]
              }
            } else if (_dialPlan === this.dialPlanList[2]) {
              item.placeholder = '000~999';
              //item.value = '000';
              if (item.name.indexOf('[endNo]') > -1) {
                item.value = '999';
              }
              item.validate.range = [[0, 999], this.$t('SubscriberIms.noZoneDial6Tip')];
              item.validate.rangeLength = [[3,3],this.$t('SubscriberIms.solid_3')]
            }
          }
        }
        if (item.name.indexOf('grptype') > -1) {
          if (_dialPlan === this.dialPlanList[1] && !propinfo.showFlag) {
            const grptype4 = { value: 4, showName: this.$t('SubscriberIms.grptype4') };
            item.options.push(grptype4);
          } else if (_dialPlan === this.dialPlanList[2]) {
            item.options = [];
            const grptype4 = { value: 4, showName: this.$t('SubscriberIms.grptype4') };
            item.options.push(grptype4);
            item.value = 4;
          }
        }
        if (item.name === 'vpnid') {
          // item.value = propinfo.vpnid;
          // item.options = [{ showName: propinfo.vpnname, value: propinfo.vpnid }];
          item.value = propinfo.vpnname;
          this.info.vpnid = propinfo.vpnid;
          item.readonly = true;
        }
      });
      // if (propinfo.opCode === 'add') {
      //   bussinessMap = subscriberArr.getTempletByGroup(0);
      // } else if (propinfo.opCode === 'batchAdd') {
      //   bussinessMap = subscriberArr.getTempletByGroup(-1);
      // }
      // return bussinessMap;
      return res;
    },
    checkDmrZone(zone)
    {
      if(zone === '00' ||
        zone === '10' ||
        zone === '20' ||
        zone === '30' ||
        zone === '40' ||
        zone === '50' ||
        zone === '60' ||
        zone === '70' ||
        zone === '80' ||
        zone === '90' ){
        return true;
      }
    },
    /**
     * 组织架构列表查询
     * @param propinfo
     * @param res
     * @returns {*}
     */
    getVpnInfo(propinfo, $this) {
      if (this.opCode === 'batchMod' && !this.checkboxMap.vpnid) {
        return;
      }
      // 组织架构查询赋值
      this.$refs.qryVpnInfoPage.show();
      console.log('vpndata', this.vpndata);
      this.$refs.organizationalTreeInner.staDoFieldsList = this.vpndata;
      this.$refs.organizationalTreeInner.getOrganizationalTreeWithNeid();
      return;
      this.paramForInner.neId = this.neid;
      const param = {

      };
      this.$axios.post('/lte/ems/subscriber/imsunms/requestCommon', param).then((response) => {
        if (response.status === 200) {
          this.$refs.qryVpnInfoPage.show();
        } else {
          // this.$layer.alert({ msg: this.$t('SubscriberIms.qryVpnFailTip') });
          EventBus.$emit('toast', { type: 'warning', content: this.$t('SubscriberIms.qryVpnFailTip') });
        }
      });
    },
    // 根据网元id获取
    initTemplateInfo() {
      this.paramForQryTemplate.neId = this.neid;
      this.paramForQryTemplate.vo['1'].neid = this.neid;
      this.$axios.post('/lte/ems/subscriber/imsunms/requestCommon', this.paramForQryTemplate).then((response) => {
        if (response.status === 200 && response.data.errorCode === '0') {
          const template = new Map();
          const res = JSON.parse(response.data.resultVal);
          res.result.forEach((item) => {
            template.set(item.tempnum, item.context);
            this.templateInfo.push({ text: item.tempname, value: item.tempnum });
          });
          this.templateInfoMap = template;
        }
      });
    },
    templateChange(args) {
      const map = JSON.parse(this.templateInfoMap.get(args.itemData.value));
      console.log(this.templateInfoMap.get(args.itemData.value), map);
      this.$refs.grpprofileInfo.setDatas(map);
      this.$refs.grpAdditionInfo && this.$refs.grpAdditionInfo.setDatas(map);
      // const $this = this;
      // $this.$refs.grpprofileInfo.reMount(JSON.parse(this.templateInfoMap.get(args.itemData.value)));
      // $this.$refs.grpAdditionInfo.reMount(JSON.parse(this.templateInfoMap.get(args.itemData.value)));
    },
    getDatas() {
      // const validateReturn = this.$refs.base.validateResult() === false
      //   ? false : (this.$refs.grpprofileInfo.validateResult() === false
      //     ? false : (this.$refs.grpAdditionInfo.validateResult() !== false));

      let validateReturn = this.$refs.base.validateResult() === false
        ? false : (this.$refs.grpprofileInfo.validateResult() !== false);
      if (this.showTgrpAddition) {
        validateReturn = validateReturn === false? false : this.$refs.grpAdditionInfo.validateResult() !== false
      }
      if (!validateReturn) {
        console.log('表单验证不通过');
        return;
      }
      const map = this.$refs.base.getDatas();
      const device = this.$refs.grpprofileInfo.getDatas();

      const returnObj = {};
      Array.from(map).forEach(([key, value]) => {
        returnObj[key] = value;
      });
      Array.from(device).forEach(([key, value]) => {
        returnObj[key] = value;
      });
      if (this.showTgrpAddition) {
        const serve = this.$refs.grpAdditionInfo.getDatas();
        Array.from(serve).forEach(([key, value]) => {
          returnObj[key] = value;
        });
      }
      console.log(returnObj);
      returnObj.vpnid = this.info.vpnid;
      return returnObj;
    },
    getGrpnumberBussiness(map) {
      // 号码拼写
      map.set('grpnum', map.get('userAlias'));
      return map;
    },
    initAnotherBussinessDatas(datas) {
      datas.confirmpassword = datas.password;
    },
    reMount() {
      this.$refs.base.reMount();
      this.$refs.grpprofileInfo.reMount();
      // this.$refs.grpAdditionInfo.reMount();
    },
    getSelectList() {
      this.$refs.base.reMount();
      this.$refs.device.reMount();
      this.$refs.serve.reMount();
    },
    clearTemplate() {
      this.showTemplate = false;
      this.$nextTick(() => {
        this.showTemplate = true;
      });
    },
    bindStyleAfterPageCreated() {
      const componentArray = this.$refs.base.$children[0].$children;
      componentArray.forEach(item => {
        console.log('==============', item);
      });
      // 修改样式
      const tds = document.getElementById('batchModbaseBusiness').querySelectorAll('table td');
      tds.forEach((item) => {
        console.log(item.firstChild, item.firstChild.childNodes[2]);
        const input = document.createElement('input');
        input.onclick = this.setStyleAndEvent;
        input.type = 'checkbox';
        input.className = 'e-icons e-frame e-check';
        item.firstChild.childNodes[0].replaceChild(input, item.firstChild.childNodes[0].children[0]);
        const dom = item.firstChild.childNodes[2].children[0];
        dom.setAttribute('readonly', 'readonly');
        dom.setAttribute('class', 'e-control e-textbox e-lib e-input readonly-background');
      });
    },
    setStyleAndEvent(args) {
      console.log('args', args);
      // if (this.styleFlag) { // true需要设置
      //
      // }
    },
    bindClickAfterPageCreatedForAdd() {
      // 输入框点击事件----根据name名称找到组件
      const componentArray = this.$refs.base.$children[0].$children;
      componentArray.forEach(item => {
        if (item.$refs.grptype) {
          console.log('item.$refs.grptype', item.$refs.grptype);
          this.grptypeRef = item.$refs.grptype.ej2Instances;
          this.grptypeRef.change = this.changeFleetWithType;
        }
        if (item.$refs['grpnum[fleet]']) {
          // this.grpnumOfFleetRef = item.$refs['grpnum[fleet]'].ej2Instances;
          this.grpnumOfFleetRef = item.$refs['grpnum[fleet]'];
          this.grpnumOfFleet = item.$refs['grpnum[fleet]'];
        }
      });
    },
    changeFleetWithType(args) {
      console.log(args.previousItemData.value);
      const oldValue = args.previousItemData.value;
      if (oldValue === 4) {
        this.$refs.base.setSelectOptions('grpnum[fleet]', this.fleetListDataNormal);
        this.$refs.base.setData('grpnum[fleet]', this.fleetListDataNormal[0].value);
      } else if (args.value === this.dialPlanList[0]) {
        this.$refs.base.setSelectOptions('grpnum[fleet]', this.fleetListData);
        this.$refs.base.setData('grpnum[fleet]', this.fleetListData[0].value);
      }
    },
    bindClickAfterPageCreated() {
      // 输入框点击事件----根据name名称找到组件
      const componentArray = this.$refs.base.$children[0].$children;
      componentArray.forEach(item => {
        if (item.$refs.vpnid) {
          console.log('有这个组件哈');
          // 输入框绑定点击
          // item.$refs.grpname.onclick = this.testFunction;

          // 输入框右侧增加"选择超链接"
          const input = document.createElement('A');
          input.onclick = this.getVpnInfo;
          input.className = 'h-subscriber-atag';
          const valueOfAtag = document.createTextNode(this.$t('SubscriberIms.selectVButton'));
          input.appendChild(valueOfAtag);
          console.log(item.$refs.vpnid);
          item.$refs.vpnid.parentElement.className = 'h-subscriber-div-innerwitha';
          item.$refs.vpnid.parentElement.appendChild(input);
          return null;
        }
        return null;
      });
    },
    testFunction() {
      console.log('请进行数据查询');
    },
    chooseGrpNam() {
      console.log('请调用人员信息管理查询');
    },
    /**
     * 更新和关闭组织架构
     */
    setChooseVpnInfo(event) {
      if (event.keyCode === 13) {
        return;
      }
      const selectNode = this.$refs.organizationalTreeInner.getNode();
      if (!selectNode) {
        // this.$layer.alert({ msg: this.$t('SubscriberIms.chooseNodeTip') });
        EventBus.$emit('toast', { type: 'warning', content: this.$t('SubscriberIms.chooseNodeTip') });
      } else {
        this.$refs.organizationalTreeInner.clear();
        this.$refs.qryVpnInfoPage.clear();
        this.$refs.qryVpnInfoPage.close();
        // const vpnidRef = this.$refs.base.$refs.bus.$refs.componentSub.filter((item) => item.$refs.vpnid);
        // vpnidRef[0].$refs.vpnid.value = selectNode.text;
        this.$refs.base.$refs.bus.setData('vpnid', selectNode.text);
        this.$refs.base.$refs.bus.validateResult(['vpnid']);
        this.info.vpnid = selectNode.id.split('_')[2];
      }
    },
    closeQryVpnInfoPage() {
      this.$refs.organizationalTreeInner.clear();
      this.$refs.qryVpnInfoPage.clear();
      this.$refs.qryVpnInfoPage.close();
    },
    $bindGrpname(refname, opCode, versionFlag) {
      const $this = this;
      $this.funcKeyUpMap.set(refname, () => {
        const baseInfo = $this.$refs.base.$refs.bus;
        const grpNameValue = baseInfo.getAttrByName(refname, 'value');

        let maxLength = 45;//2.2 接口处是51(测试时，传51报错，最大50)，设备侧批量操作会补充5个字符（队号和个号）
        let byteTip = this.$t('MML.maxBytesLength', [45]);
        //2.3----默认50
        if(!versionFlag) {
          maxLength = 50;
          byteTip = this.$t('MML.maxBytesLength', [50]);
        }
        if (opCode === 'add' || opCode === 'mod' || opCode === 'batchMod') {
          maxLength = 50;//接口处是51，设备侧批量操作会补充5个字符（队号和个号）
          byteTip = this.$t('MML.maxBytesLength', [50]);
        }
        const result = this.maxBytesValidateFn(grpNameValue, maxLength);
        if(!result) {
          let newRule = {};
          newRule = {
            required: [true, this.$t('SubscriberIms.require')],
            rangeLength: [[1, 50], this.$t('SubscriberIms.charAt1To50',[1,50])],
            regex: ["^[_0-9a-zA-Z\\\u4E00-\\\u9FA5]+$", this.$t('SubscriberIms.invalideChar')],
            maxLength: [this.maxBytesValidateFn, byteTip],
          };
          baseInfo.removeValidate(refname);
          baseInfo.setValidate(refname, newRule);
        }
      });
    },
    maxBytesValidateFn(args, maxLength) {
      if (this.showTgrpAddition) {// 2.2
        if (maxLength === undefined) {
          if(this.opCode === 'add' || this.opCode === 'mod' || this.opCode === 'batchMod') {
            maxLength = 50;
          } else {
            maxLength = 45;//接口处是51，设备侧批量操作会补充5个字符（队号和个号）
          }
        }
      } else {//2.3
        maxLength = 50;
      }

      return this.computeByteSize(args) <= maxLength;
    },
    // 计算字符串所占字节数（UTF-8）
    computeByteSize(str) {
      let byteSize = 0;
      console.log("str=", str);
      const strNew = str.value ? str.value : str;
      for (const chr of strNew) {
        //ES6提供了codePointAt方法，能够正确处理4个字节储存的字符，返回一个字符的码点
        const charCode = chr.codePointAt(0);
        if(0 <= charCode && charCode <= 0x7f) {
          byteSize += 1;
        } else if (128 <= charCode && charCode <= 0x7ff) {
          byteSize += 2;
        } else if (2048 <= charCode && charCode <= 0xffff) {
          byteSize += 3;
        } else if (65536 < charCode && charCode <= 0x1FFFFF) {
          byteSize += 4;
        } else if (0x200000 < charCode && charCode <= 0x3FFFFFF) {
          byteSize += 5;
        } else if (0x4000000 < charCode && charCode <= 0x7FFFFFFF) {
          byteSize += 6;
        } else {
          byteSize += 6;
        }
      }
      return byteSize;
    },
  },
  data() {
    return {
      POC_VERSION_23: '23',
      POC_VERSION_22: 'V22',
      showTgrpAddition: false,
      oldValue: 0,
      vpndata: [],
      disableNode:[],
      styleFlag: false,
      hasReset: true,
      showTemplate: true,
      checkboxMap: {
        grpprofileInfo: false,
        base: false,
        grpAdditionInfo: false
      },
      neid: '',
      msgid: '',
      templateInfo: [], // 宽带模板列表
      templateInfoMap: {}, // 模板信息缓存
      dialPlan: '',
      info: {
        vpnid: '',
      },
      formParamsBase: {
        json: '',
        formId: `${this.opCode}baseBussiness`,
        subObject: '',
        modelName: 'noGroup',
      },
      formParamsGrpprofileInfo: {
        json: '',
        formId: `${this.opCode}grpprofileInfoBussiness`,
        subObject: '',
        modelName: 'grpprofileInfo',
      },
      formParamsBaseNew: {
        formId: 'batchAddbaseBussiness',
        modelName: 'noGroup',
        showCheckBox: { type: Boolean, default: false }
      },
      formParamsGrpprofileInfoNew: {
        formId: 'batchAddgrpprofileInfoBussiness',
        modelName: 'grpprofileInfo'
      },
      formParamsGrpAdditionInfo: {
        json: '',
        formId: `${this.opCode}grpAdditionInfoBussiness`,
        subObject: '',
        modelName: 'grpAdditionInfo',
      },
      formParamsGrpAdditionInfoNew: {
        formId: 'batchAddAdditionInfoBussiness',
        modelName: 'grpAdditionInfo'
      },
      grpnumList: [{
        showName: 'tett',
        value: 5555
      }],
      paramForGetJson: {
        msgid: this.msgid,
        neid: this.neid
      },
      paramForInner: {
        vo: {
          0: this.neid,
          1: 'TcfRegionNum',
          2: 'RegionNum'
        },
        info: {
          neId: this.neid,
          operation: 'getZone'
        }
      },
      paramForQryTemplate: {
        vo: {
          0: { page: '1', pageSize: 1000 },
          1: { neid: this.neid, tempname: '', temptype: 2, neid: this.neid }
        },
        info: {
          neId: this.neid,
          operation: 'qryTemplate'
        },
        page: {
          pageNo: 1,
          pageSize: 1000
        }
      },
      dialog: {
        styles: {
          width: '20%',
          height: '38%',
          visible: false,
          model: true,
        },
        stylesWithIndex: {
          width: '20%',
          height: '48%',
          visible: false,
          model: true,
          zIndex: 1000,
        },
        element: {
          eleQryVpnInfo: {
            target: this.$refs.qryVpnInfoPage,
            refName: 'qryVpninfo',
            buttonGroup: [
              {
                click: this.closeQryVpnInfoPage, buttonModel: { content: this.$t('SubscriberIms.cancel') }
              },
              {
                click: this.setChooseVpnInfo, buttonModel: { content: this.$t('SubscriberIms.confirm'), isPrimary: true }
              }
            ],
            title: this.$t('SubscriberIms.organization'),
            isClose: true
          }
        },
      },
      showCheckbox: false,
      showCheckboxa: false,
      arrDeviceBak: [],
      arrBaseBak: [],
      arrAdditionalBak: [],
      grptypeVal: 1,
      grptypeRefChange: undefined,
      grptypeRef: undefined,
      grpnumOfFleet: undefined,
      grpnumOfFleetRef: undefined,
      fleetListData: [
        { showName: 90, value: 90 }, { showName: 97, value: 97 }, { showName: 98, value: 98 }, { showName: 99, value: 99 }
      ],
      fleetListDataNormal: [],
      dialPlanList: [4, 5, 6], // 网管只支持p3\dmr\浙江拨号方案
      funcKeyUpMap: undefined,
    };
  },
  // mounted() {
  //   console.log("=============");
  //   this.$nextTick(function () { this.initState(this.arrBaseBak, this.arrDeviceBak); });
  // }
  computed: {
    bindOnJudgeNameLengthInfo() {
      this.funcKeyUpMap = new Map();
      this.$bindGrpname('grpname', this.opCode, this.showTgrpAddition);
      return this.funcKeyUpMap;
    }
  },
};
</script>

<style scoped>

</style>
